import {
  SelectItem,
  useLocationOptionsQuery,
} from '@kistill/client/data-access'
import {
  AutocompleteChangeDetails,
  AutocompleteChangeReason,
  Grid,
  IconButton,
  TextFieldProps,
} from '@mui/material'
import { AutocompleteElement } from 'react-hook-form-mui'
import AddIcon from '@mui/icons-material/Add'

interface LocationSelectorProps {
  name: string
  label: string
  inputProps?: TextFieldProps
  setOpenLocationPopup?: (value: boolean) => void
  setSelectedLocations: (selectedLocation: SelectItem[]) => void
  itemTypeGuid: string | undefined
  required?: boolean | undefined
}

export function KistillLocationSelector({
  name,
  label,
  setOpenLocationPopup,
  setSelectedLocations,
  itemTypeGuid,
  required = false,
}: LocationSelectorProps) {
  const { data } = useLocationOptionsQuery({
    variables: {
      itemTypeGuid: itemTypeGuid ? itemTypeGuid : '',
    },
    fetchPolicy: 'network-only',
  })

  const locationOptions = data?.locationOptions?.map((x) => {
    return { id: x.id, label: x.title } as unknown as SelectItem
  })

  const onAutoChange = (
    _event: React.SyntheticEvent<Element, Event>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value: any,
    _reason: AutocompleteChangeReason,
    _details?: AutocompleteChangeDetails<unknown> | undefined,
  ) => {
    setSelectedLocations(value)
  }

  return (
    <Grid item container alignItems='center'>
      <Grid item xs={11}>
        <AutocompleteElement
          multiple
          name={`${name}`}
          label={label}
          options={locationOptions || []}
          autocompleteProps={{
            onChange: onAutoChange,
          }}
          required={required}
          rules={{
            required: required ? 'Vinsamlegast fylltu út þennan reit' : false,
          }}
        />
      </Grid>
      {setOpenLocationPopup && (
        <Grid item xs={1} justifyContent='center' pl={1}>
          <IconButton
            onClick={() => setOpenLocationPopup(true)}
            sx={{
              p: '4px',
              backgroundColor: (theme) => theme.palette.primary.main,
              color: (theme) => theme.palette.common.white,
            }}
          >
            <AddIcon />
          </IconButton>
        </Grid>
      )}
    </Grid>
  )
}
